import CardHotelList from './CardHotelList';
export default CardHotelList;
